import { DscrScenario } from '../types/dscr'

export const savedScenarios: DscrScenario[] = [
  {
    id: 'scenario-1',
    name: 'Scenario 1 — Market rents (appraisal 1007)',
    units: [
      { id: 'unit-1', label: 'Unit 1', monthlyRent: 2650 },
      { id: 'unit-2', label: 'Unit 2', monthlyRent: 2500 },
      { id: 'unit-3', label: 'Unit 3', monthlyRent: 2275 },
    ],
    housingPayment: {
      principalAndInterest: 5124.18,
      homeownersInsurance: 318.0,
      propertyTax: 691.25,
      mortgageInsurance: 0,
      other: 145.0,
    },
    dscr: 1.1836,
    savedBy: 'Dana Whitfield',
    savedAt: '2026-09-14T10:41:00-06:00',
    version: 2,
    note: 'Baseline off the 1007 market rent schedule.',
  },
  {
    id: 'scenario-2',
    name: 'Scenario 2 — In-place leases only',
    units: [
      { id: 'unit-1', label: 'Unit 1', monthlyRent: 2400 },
      { id: 'unit-2', label: 'Unit 2', monthlyRent: 2400 },
      { id: 'unit-3', label: 'Unit 3', monthlyRent: 0 },
    ],
    housingPayment: {
      principalAndInterest: 5124.18,
      homeownersInsurance: 318.0,
      propertyTax: 691.25,
      mortgageInsurance: 0,
      other: 145.0,
    },
    dscr: 0.7639,
    savedBy: 'Robert Hulse',
    savedAt: '2026-09-12T15:08:00-06:00',
    version: 1,
    note: 'Unit 3 vacant — worst case for credit.',
  },
  {
    id: 'scenario-3',
    name: 'Scenario 3 — 25% down, 6.99% buydown',
    units: [
      { id: 'unit-1', label: 'Unit 1', monthlyRent: 2650 },
      { id: 'unit-2', label: 'Unit 2', monthlyRent: 2500 },
      { id: 'unit-3', label: 'Unit 3', monthlyRent: 2275 },
    ],
    housingPayment: {
      principalAndInterest: 4618.9,
      homeownersInsurance: 318.0,
      propertyTax: 691.25,
      mortgageInsurance: 0,
      other: 145.0,
    },
    dscr: 1.2792,
    savedBy: 'Dana Whitfield',
    savedAt: '2026-09-11T11:26:00-06:00',
    version: 1,
    note: 'Priced with 2 discount points to clear 1.25x.',
  },
]

export const currentUser = 'Dana Whitfield'
